import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as r } from "react";
import { I as a } from "../../../../IconBase-CxZyIWw2.js";
const s = r((l, e) => /* @__PURE__ */ o.jsx(
  a,
  {
    ref: e,
    ...l,
    image: (i) => /* @__PURE__ */ o.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...i,
        children: /* @__PURE__ */ o.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M30.866 17.985a4 4 0 0 0 0-3.97l-5.714-10A4 4 0 0 0 21.679 2H10.32a4 4 0 0 0-3.473 2.015l-5.714 10a4 4 0 0 0 0 3.97l5.714 10A4 4 0 0 0 10.321 30H21.68a4 4 0 0 0 3.473-2.015zM10.683 20H8.849v-8.402h1.834v3.685l2.947-3.685h2.215l-2.854 3.398 2.847 4.814 2.737-8.212h2.55L23.871 20h-1.94l-.62-2.016h-3L17.685 20h-3.868l-2.033-3.568-1.101 1.312zm9.14-6.873-1.048 3.369h2.08z",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
s.displayName = "KojicAcidIcon";
export {
  s as KojicAcidIcon,
  s as default
};
//# sourceMappingURL=index.js.map
